/**
 * Separates a number with a specified separator.
 *
 * @param {string} Number - The number to be separated.
 * @param {number} [separateNumber=3] - The number of digits between separators.
 * @param {string} [separator=','] - The separator to use.
 * @returns {string} - The formatted number as a string.
 *
 * @example
 * // returns '1,234,567.89'
 * separate('1234567.89', 3, ',');
 *
 * @example
 * // returns '12-34-567.89'
 * separate('1234567.89', 2, '-');
 */
export default function separate(Number, separateNumber = 3, separator = ",") {
    Number += '';
    Number = Number.replace(',', '');
    let x = Number.split('.');
    let y = x[0];
    let z = x.length > 1 ? '.' + x[1] : '';
    let rgx = new RegExp(`(\\d+)(\\d{${separateNumber}})`);
    while (rgx.test(y))
        y = y.replace(rgx, `$1${separator}$2`);
    return y + z;
}
